import { render } from "./DashboardTV4.vue?vue&type=template&id=e86294ca"
import script from "./DashboardTV4.vue?vue&type=script&lang=js"
export * from "./DashboardTV4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__